import httpClient, { handleSuccess, handleError, apiHeader } from './httpClient'

export function logSearchHistory(search, functionId) {
  const params = new URLSearchParams()
  const dateKeys = []
  Object.keys(search.date).map(key => {
    if (search.date[key].before || search.date[key].after) {
      dateKeys.push(key)
    }
  })
  if (dateKeys.length) {
    params.append('date', dateKeys)
  }

  if (search.text) {
    params.append('text', search.text)
  }

  const selectKeys = []
  Object.keys(search.select).map(key => {
    if (search.select[key] !== 'all') {
      selectKeys.push(key + '=' + search.select[key])
    }
  })
  if (selectKeys.length) {
    params.append('select', selectKeys)
  }

  if (!params.toString()) {
    // 検索条件が何もないのでログは残さない
    return
  }

  params.append('function_id', functionId)
  return httpClient.post('search_history/log_search_history', params, apiHeader).then(handleSuccess).catch(handleError)
}
